import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#2e3436"><path d="M1.605 4.082A1.003 1.003 0 001 5v8c0 .55.448 1 1 1h9.523L9.99 12.467A4 4 0 018 13c-3.073-.002-4.996-3.324-3.467-5.99zm4.452 4.451a2 2 0 002.41 2.41zM1.531.469L.47 1.53l14 14 1.062-1.062z" /><path d="M6 2c-.55 0-1 .45-1 1v1H4l1.72 1.72A3.973 3.973 0 018 5a4 4 0 014 4c0 .849-.27 1.632-.72 2.28L14 14c.552 0 1-.45 1-1V5c0-.55-.448-1-1-1h-3V3c0-.55-.45-1-1-1zm2 5c-.293 0-.57.067-.82.18l2.64 2.64c.114-.25.18-.527.18-.82a2 2 0 00-2-2z" style={{
        marker: "none"
      }} color="#bebebe" overflow="visible" /></g></svg>;
}

export default SvgComponent;